import { defineComponent, computed, resolveDirective, withDirectives, createElementBlock, openBlock, normalizeClass, createBlock, createCommentVNode, resolveDynamicComponent, withCtx, createVNode, normalizeStyle, createElementVNode } from 'vue';
import _sfc_main$1 from './basler-components.es81.js';
/* empty css                       */

const _hoisted_1 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "InfoIcon",
  props: {
    icon: { default: "info" },
    tag: { default: "button" },
    hasPulseAnimation: { type: Boolean, default: false },
    tooltipText: { default: "" },
    tooltipMaxWidth: { default: 350 },
    tooltipPlacement: { default: "auto" },
    tooltipTrigger: { default: "mouseenter focus" },
    labelText: { default: "" },
    labelMaxWidth: { default: "none" },
    style: { default: "info" },
    styleScope: { default: "icon-only" }
  },
  emits: ["click", "mouseover", "mouseleave"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const tooltipProps = computed(() => {
      return {
        content: props.tooltipText,
        maxWidth: props.tooltipMaxWidth,
        placement: props.tooltipPlacement,
        trigger: props.tooltipTrigger,
        allowHTML: true
      };
    });
    const emit = __emit;
    return (_ctx, _cache) => {
      const _directive_tippy = resolveDirective("tippy");
      return withDirectives((openBlock(), createElementBlock("div", {
        class: normalizeClass([
          "info-icon",
          { "info-icon--pulse": _ctx.hasPulseAnimation },
          { "info-icon--interactive": _ctx.tag === "button" || _ctx.tooltipText !== "" },
          { "info-icon--with-label": _ctx.labelText !== "" },
          `info-icon--is-${_ctx.style}-style`,
          `info-icon--is-${_ctx.styleScope}-style`
        ]),
        onClick: _cache[0] || (_cache[0] = ($event) => emit("click")),
        onMouseover: _cache[1] || (_cache[1] = ($event) => emit("mouseover")),
        onMouseleave: _cache[2] || (_cache[2] = ($event) => emit("mouseleave"))
      }, [
        (openBlock(), createBlock(resolveDynamicComponent(_ctx.tag), {
          type: _ctx.tag === "button" ? "button" : void 0,
          class: "info-icon__icon"
        }, {
          default: withCtx(() => [
            createVNode(_sfc_main$1, { name: _ctx.icon }, null, 8, ["name"])
          ]),
          _: 1
        }, 8, ["type"])),
        _ctx.labelText !== "" ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "info-icon__label",
          style: normalizeStyle(_ctx.labelMaxWidth !== "none" ? `max-width: ${_ctx.labelMaxWidth}px` : void 0)
        }, [
          createElementVNode("div", { innerHTML: _ctx.labelText }, null, 8, _hoisted_1)
        ], 4)) : createCommentVNode("", true)
      ], 34)), [
        [_directive_tippy, _ctx.tooltipText !== "" ? tooltipProps.value : void 0]
      ]);
    };
  }
});

export { _sfc_main as default };
